export const styles = {
  cardActionStyleSmall: {
    zIndex: 2,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  containerSmall: {
    padding: '3em 1em 6em 1em',
  },
  containerMedium: {
    padding: '0em 1em 1em 1em'
  },
  containerSubTitle:{color:'#788195', paddingTop: 10, paddingBottom:10},
  containerSubBox: {
    marginTop: '2rem'
  },
  mediumIcon: {
    width: 36,
    height: 36,
  },
  marketerBoxSmall: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '3em 0em 2em',
    alignItems: 'center',
    flex: 1,

  },
  marketerBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '1em 0em 1em',
    alignItems: 'center',
    flex: 1,
  },
  medium: {
    width: 72,
    height: 72,
    padding: 8,
  },
  tabsContainer: {
   width: '100%',
  },
  tabBox: {
   padding: 0,
  },
  profileInfo: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
  },
  itemBoxSmall: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '1em auto'
  }
}



// WEBPACK FOOTER //
// ./src/marketers/styles.js